import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row } from "reactstrap";
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation } from "react-router-dom";

function AddEdit_QrImage() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/QrImage";
  const API_URL_SAVE = API_WEB_URLS.QrImage + "/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/QrImageEdit/Id";

  const [state, setState] = useState({
    id: 0,
    formData: { Name: '', file: null },
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    // Fn_FillListData(dispatch, setState, "formData", API_URL + "/Id/0");

    const Id = (location.state && location.state.Id) || 0;

    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
  
  });

  const handleSubmit = (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const vformData = new FormData();

    if (values.file) {
      vformData.append("IMG", values.file);
    }
    vformData.append("Name", values.Name);
    vformData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData: vformData } },
      API_URL_SAVE,
      true,
      "imageId"
    ).finally(() => setSubmitting(false));
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form className="form-horizontal">
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
                <Field
                  id="Name"
                  name="Name"
                  type="text"
                  className="form-control"
                />
                <ErrorMessage
                  name="Name"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="file" className="form-label">
                  Upload QR Code Image
                </label>
                <input
                  id="file"
                  name="file"
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(event) => {
                    setFieldValue("file", event.currentTarget.files[0]);
                  }}
                />
                <ErrorMessage
                  name="file"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_QrImage;
